var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import SubmitServiceApi from '~/api/submission-engine/submitService';
import { keysToCamel } from '~/utils/toCamelCase';
const fetchFileName = (file_id) => __awaiter(void 0, void 0, void 0, function* () {
    const response = keysToCamel(yield SubmitServiceApi.search(undefined, undefined, undefined, file_id));
    if (response.data.length === 0)
        return '';
    return response.data[0].fileName;
});
export default fetchFileName;
